import { HandbookRes } from '~/types/Handbook';
import axios from './axios';

export const getHandbook = () => {
  return axios.get<HandbookRes>('/misc/handbook').then((res) => res.data);
};
